import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

const surveysSelector = createSelector(
  (state: RootState) => state.surveyState,
  (state) => state.surveys,
);

const surveyPaginationSelector = createSelector(
  (state: RootState) => state.surveyState,
  (state) => state.surveyPagination,
);

const surveyQuestionSelector = createSelector(
  (state: RootState) => state.surveyState,
  (state) => state.surveyQuestion,
);

const surveyAnswersSelector = createSelector(
  (state: RootState) => state.surveyState,
  (state) => state.surveyQuestion?.answers,
);
const surveysIds = createSelector(
  (state: RootState) => state.surveyState,
  (state) => state.surveys.map((survey) => survey.id),
);

export const surveySelectors = {
  surveys: surveysSelector,
  surveyPagination: surveyPaginationSelector,
  surveyQuestion: surveyQuestionSelector,
  surveyAnswers: surveyAnswersSelector,
  surveysIds,
};
